<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-if="adminOnly"
                            v-model="entity.title"
                            label="Название"
                            placeholder="Введите название"
                        />
                        <CInput
                            v-if="adminOnly"
                            v-model="entity.code"
                            label="Код"
                            placeholder="Введите код"
                        />
                        <CInput
                            v-if="adminOnly"
                            v-model="entity.short_name"
                            label="Короткое название"
                            placeholder="Введите короткое название"
                        />
                        <CInput
                            v-if="adminOnly"
                            v-model="entity.legal_entity"
                            label="Юр. лицо"
                            placeholder="ООО…"
                        />
                        <CInput
                            v-if="adminOnly"
                            v-model="entity.alias"
                            label="Алиас"
                            placeholder="Введите алиас"
                        />
                        <CTextarea
                            v-model="entity.description"
                            label="Краткое описание"
                            placeholder="Укажите краткое описание (не более 255 символов)"
                        />
                        <CTextarea
                            v-model="entity.synonyms"
                            label="Синонимы"
                            placeholder="Укажите синонимы для поиска" 
                        />
                        <CSelect
                            v-if="adminOnly"
                            class="mb-3"
                            label="Башня"
                            placeholder="Башня..."
                            :options="towers"
                            :value.sync="entity.tower"
                        />
                        <div v-if="adminOnly" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow v-if="adminOnly">
                                <CCol tag="label" class="col-form-label">
                                    <b>Лейблы</b>
                                </CCol>
                            </CRow>
                            <CRow 
                                v-if="adminOnly"    >
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">
                                    Новый сервис
                                </CCol>
                                <CCol>
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="entity.is_new_label" 
                                    />
                                </CCol>
                            </CRow>
                            <CRow 
                                v-if="adminOnly">
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">
                                    Веган
                                </CCol>
                                <CCol>
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="entity.vegan_label" 
                                    />
                                </CCol>
                            </CRow>
                            <CRow
                                v-if="adminOnly">
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">
                                    Проверено МИРСИТИ
                                </CCol>
                                <CCol>
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="entity.verified_mircity_label" 
                                    />
                                </CCol>
                            </CRow>
                        </div>
                        <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <WorkingHours 
                                :working-hours="workingHours"
                                :service-type="entity.entityType.code"
                                @working-hours-update="fetch"
                            />
                            <CRow v-if="adminOnly">
                                <CCol
                                    tag="label"
                                    sm="3"
                                    class="col-form-label">
                                    Скрывать когда закрыт
                                </CCol>
                                <CCol sm="9">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="entity.hide"
                                    />
                                </CCol>
                            </CRow>
                        </div>

                        <div v-if="adminOnly" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow>
                                <CCol tag="label" class="col-form-label flex align-items-center">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        class="mr-3"
                                        :checked.sync="entity.one_click_purchase.enabled" 
                                    />
                                    <b>Настройка "Покупка в 1 клик"</b>
                                </CCol>
                            </CRow>
                            <CRow v-if="entity.one_click_purchase.enabled">
                                <CCol md="3" tag="label" class="col-form-label">
                                    Текст на кнопке
                                </CCol>
                                <CCol md="9">
                                    <CInput
                                        v-model="entity.one_click_purchase.title"
                                    />
                                </CCol>
                            </CRow>
                            <CRow v-if="entity.one_click_purchase.enabled">
                                <CCol md="3" tag="label" class="col-form-label">
                                    Продукт, добавляемый в корзину
                                </CCol>
                                <CCol md="9">
                                    <select
                                        v-model="entity.one_click_purchase.product_id"
                                        class="form-control"
                                    >
                                        <option disabled :value="null">Выберите продукт...</option>
                                        <option v-for="product in entityProducts" :key="product.id" :value="product.id">
                                            {{ product.title }}
                                        </option>
                                    </select>
                                </CCol>
                            </CRow>
                        </div>

                        <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow>
                                <CCol tag="label" class="col-form-label flex align-items-center">
                                    <b>Кнопка «В корзину»</b>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="3" tag="label" class="col-form-label">
                                    Ссылка кнопки
                                </CCol>
                                <CCol md="9">
                                    <CInput
                                        v-model="entity.cart_button_title"
                                        placeholder="Текст на кнопке"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol md="3" tag="label" class="col-form-label">
                                    Текст на кнопке
                                </CCol>
                                <CCol md="9">
                                    <CInput
                                        v-model="entity.cart_button_link"
                                        placeholder="Ссылка кнопки"
                                    />
                                </CCol>
                            </CRow>
                        </div>

                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Рекламный партнер
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.is_advertisement"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"
                                style="margin-bottom: 10px">
                                Отображать только опции продукта
                            </CCol>
                            <CCol sm="3">
                                <select
                                    v-model="entity.main_product_id"
                                    class="form-control"
                                    style="width: 250px;"
                                >
                                    <option disabled :value="null">Выберите продукт...</option>
                                    <option v-for="product in entityProducts" :key="product.id" :value="product.id">
                                        {{ product.title }}
                                    </option>
                                </select>
                            </CCol>
                            <CCol sm="2">
                                <CButton color="danger" @click="clearMainProduct">
                                    Очистить продукт
                                </CButton>
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Убрать применение промокода
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.hide_promocode"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Отключить применение тарифов по зонам</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.delivery_zone_disabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Использовать для каждого товара свой НДС
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.use_product_vat"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow v-if="adminOnly">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Архив
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="entity.archive"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                    <CButton
                        v-if="adminOnly"
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true"
                    >Удалить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Вы действительно хотите удалить сервис? Это действие
                        нельзя будет отменить.
                    </p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteEntity"
                    >Удалить</CButton
                    >
                </div>
            </template>
        </CModal>
        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="disabledModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>
                        Отключение сервиса по причине: <br> <strong>"указать причину"</strong> до <strong>"указать дату"</strong>.
                    </p>
                    <br>
                    <div>
                        <label>Причина отключения сервиса:</label>
                        <CInput
                            v-model="entity.why_is_it_off"
                            placeholder="Причина отключения"
                        />
                    </div>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="disabledModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="saveDisabledService">Сохранить</CButton>
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import WorkingHours from '@/components/WorkingHoursUpdate';
    import { xssRegEx } from '@/utils/rules';
    import { BUSINESS_LABEL } from '@/utils/servicesLabel'

    export default {
        name: 'EntityEdit',

        components: {
            EntityTabLinks,
            WorkingHours
        },

        data() {
            return {
                workingHours: [],
                schedule: undefined,
                enabledOnServer: false,
                entity: {
                    service_label: '',
                    id: 0,
                    code: '',
                    title: '',
                    short_name: '',
                    legal_entity: '',
                    alias: '',
                    description: '',
                    synonyms: '',
                    picture: '',
                    square_picture: '',
                    small_cards: false,
                    categories_page: false,
                    show_description_picture: false,
                    extended_schedule: false,
                    tower: 0,
                    open_at: '',
                    close_at: '',
                    min_price: 0,
                    min_price_pickup: 0,
                    phone: '',
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    delivery_zone_disabled: false,
                    enabled: true,
                    archive: false,
                    use_product_vat: false,
                    position: 0,
                    calories_100g: false,
                    is_advertisement: false,
                    is_new_label: false,
                    vegan_label: false,
                    verified_mircity_label: false,
                    not_close_service: false,

                    main_product_id: null,

                    why_is_it_off: '',
                    who_turned_off: '',
                    shutdown_date: '',

                    one_click_purchase: {},
                    cart_button_title: null,
                    cart_button_link: null
                },
                entityProducts: [],
                towers: [],
                selectedPicture: null,
                selectedSquarePicture: null,
                deleteModal: false,
                disabledModal: false,
                activityСheck: false,
            };
        },

        computed: {
            pictureUrl() {
                if (this.entity.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.picture
                    );
                } else {
                    return '';
                }
            },
            squarePictureUrl() {
                if (this.entity.square_picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.entity.square_picture
                    );
                } else {
                    return '';
                }
            },
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings'))
                    .is_business_admin;
            },
        },

        async mounted() {
            await this.fetch();
            await this.fetchEntityProducts();
        },

        methods: {
            clearMainProduct() {
                this.entity.main_product_id = null;
            },
            async fetchEntityProducts() {
                const id = this.$route.params.id;
                try {
                    const { data: response } = await Vue.axios.get(`/entities/${id}/entity_products`);
                    this.entityProducts = response;
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки продуктов.');
                }
            },
            async fetch() {
                const id = this.$route.params.id;
                Vue.axios
                    .get('/entities/get/' + id)
                    .then(resp => {
                        if(!resp.data.one_click_purchase){
                            resp.data.one_click_purchase = {};
                        }
                        this.entity = resp.data;
                        this.entity.archive = !!resp.data.archive;
                        this.enabledOnServer = resp.data?.enabled;
                        this.allowedSave = false;
                        if(resp.data.schedule.length != 0){
                            this.schedule = resp.data.schedule;
                        }
                        if (resp.data.workingHours.length != 0) {
                            this.workingHours = resp.data.workingHours;
                        }
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });

                if (!this.towers.length) {
                    const towers = [{ value: null, label: 'Башня...' }];
                    Vue.axios
                        .get('/address')
                        .then(({ data }) => {
                            data.forEach(tower => {
                                towers.push({ value: tower.id, label: tower.name });
                            });
                        });
                    this.towers = towers;
                }
            },
            setSchedule(schedule){
                this.schedule = schedule;
            },

            async save() {
                if (!this.entity.title) {
                    this.$root.$emit('showError', 'Укажите название сервиса.');
                    return;
                }

                if (this.enabledOnServer && !this.entity.enabled && !this.allowedSave) {
                    this.disabledModal = true;
                    return;
                }

                this.entity.schedule = this.schedule;

                this.entity.why_is_it_off = this.enabledOnServer && !this.entity.enabled && this.entity.why_is_it_off ? "" + this.entity.why_is_it_off : null;
                this.entity.min_price = this.entity.min_price ? +this.entity.min_price : 0;
                this.entity.min_price_pickup = this.entity.min_price_pickup ? +this.entity.min_price_pickup : 0;

                try {
                    let formData = new FormData();
                    await Vue.axios.post(`/entities/update/${this.$route.params.id}`,this.entity);

                    this.goBack();
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            async saveDisabledService() {
                if (!this.entity.why_is_it_off && !this.entity.enabled) {
                    alert('Укажите причину отключения');
                    return;
                }
                this.allowedSave = true;

                this.save();
            },

            deleteEntity() {
                Vue.axios
                    .delete('/entities/' + this.entity.id)
                    .then(() => {
                        this.$router.push({ path: `/entities/${this.$route.params.code}` });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({
                    path: `/entities/${this.$route.params.code}/${this.$route.params.id}`,
                });
            },
        },
    };
</script>
